function Collapser() {

  "use strict";

  var COLLAPSER_TRIGGER = '.js-collapser-trigger',
      COLLAPSER_EXPANDED = 'collapser--expanded';

  // window.removeEventListener('optimizedResize', showHideElements);
  // window.addEventListener('optimizedResize', showHideElements);

  showHideElements();
  $( COLLAPSER_TRIGGER ).off('click', onClick);
  $( COLLAPSER_TRIGGER ).on('click', onClick);

  function onClick(event) {
    // toggle expanded class
    $(this).toggleClass(COLLAPSER_EXPANDED);

    // if collapser data attribute is set then also toggle expanded class on that target
    var $collapser = $('#' + this.getAttribute('data-target'));

    if ($collapser.length) {

      $collapser.height($collapser[0].scrollHeight);
      $collapser.toggleClass(COLLAPSER_EXPANDED);

      if (!$collapser.hasClass(COLLAPSER_EXPANDED)) {

        $collapser.animate({
          height: 0
        }, 400);

      } else {

        $collapser.height(0);

        $collapser.animate({
          height: $collapser[0].scrollHeight
        }, 400, function () {
          $collapser.height('auto');
        });
      }

    }

    // check to see if it's part of an accordion and collapse all other trigger elements with the same accordion value
    var _this = this;

    $('.' + COLLAPSER_EXPANDED + '[data-accordion=' + this.getAttribute('data-accordion') + ']').each(function (index) {
      if (_this != this) {
        // remove expanded class
        $(this).removeClass(COLLAPSER_EXPANDED);

        // if collapser data attribute is set then also remove expanded class on that
        var $collapser2 = $('#' + this.getAttribute('data-target'));
        $collapser2.removeClass(COLLAPSER_EXPANDED);
        $collapser2.animate({
          height: 0
        }, 400);
      }
    });
  }

  function showHideElements() {
    $(COLLAPSER_TRIGGER).each(function (i) {
      // hide collapser if not needed
      showHideElement(this);
    });
  }

  function showHideElement(element) {
    var $item = $('#' + element.getAttribute('data-target'));

    if ($item.length) {
      var minHeight = parseInt($item.css('min-height'), 10);
      var $prevElement = $(element).prev();

      if (minHeight != 0 && $item[0].scrollHeight <= minHeight + 2) {
        $(element).hide();
      } else {
        $(element).show();
      }
    }
  }

}

module.exports = Collapser;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/02_collapser.js